import { render, staticRenderFns } from "./smsDialogTips.vue?vue&type=template&id=1311c20f"
import script from "./smsDialogTips.vue?vue&type=script&lang=js"
export * from "./smsDialogTips.vue?vue&type=script&lang=js"
import style0 from "./smsDialogTips.vue?vue&type=style&index=0&id=1311c20f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports